<template>
  <b-navbar :mobile-burger="false">
    <template slot="brand">
      <div
        id="menu-toggle"
        class="navbar-item"
        @click="toggleMenu()"
        v-gUIde="{heading:'Menu',content:'Quick access to page sections and other configurations.',step:1, action:toggleMenu, delay:700}"
      >
        <span v-if="!showMenu" class="fs-keep-icon-regular">!burger</span>
        <span v-if="showMenu" class="fs-keep-icon-regular">!close</span>
      </div>
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="@/assets/keep-logo.png" alt="keep-logo" />
      </b-navbar-item>
    </template>
    <template slot="burger"></template>

    <template slot="end">
      <!-- <b-navbar-item>
        <b-button id="menu-toggle" size="is-medium" @click="toggleMenu()">
          <b-icon icon="bars" v-if="!showMenu"></b-icon>
          <b-icon icon="times" v-if="showMenu"></b-icon>
        </b-button>
        <transition name="slide-fade">
          <b-menu v-if="showMenu" class="category-menu">
            <b-menu-list label="Menu">
              <b-menu-item
                v-for="category in $store.state.roles[$store.state.currentRole]
              .categories"
                :key="category.categoryTitle"
                :icon="category.categoryIcon"
                :label="category.categoryTitle + ' (' + category.cards.length + ')'"
                @click="changeCategory(category.id)"
              ></b-menu-item>

              <b-menu-item>
                <template slot="label">
                  <b-icon icon="user" slot="trigger"></b-icon>
                  {{ displayRole }}
                  <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                    <b-icon icon="chevron-circle-down" slot="trigger"></b-icon>

                    <b-dropdown-item
                      aria-role="listitem"
                      v-for="(role, roleKey) in roles"
                      :key="roleKey"
                      @click="changeRole(roleKey)"
                    >{{ role.title }}</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-menu-item>
            </b-menu-list>
          </b-menu>
        </transition>
      </b-navbar-item>-->
    </template>
  </b-navbar>
</template>

<script>
import { get, sync } from "vuex-pathify";

export default {
  name: "App",
  components: {},
  data: function () {
    return {
      role: "",
      isActive: true,
      showMenu: false,
      showqr: false,
    };
  },
  methods: {
    changeRole: function (newRole) {
      this.$store.commit("SET_ROLE", newRole);
      console.log("new role", this.$store.state.currentRole);
      this.$store.commit("SET_CATEGORY", 0);
    },
    changeCategory: function (newCategory) {
      //this.chosenCategory = newCategory;
      this.$store.commit("SET_CATEGORY", newCategory);
      console.log(this.$store.state.currentCategory);
      //console.log(this.chosenCategory);
    },
    toggleMenu() {
      this.mobileSidebarActive = !this.mobileSidebarActive;
    },
  },
  computed: {
    mobileSidebarActive: sync("mobileSidebarActive"),
    roles() {
      return this.$store.state.roles;
    },
    displayRole() {
      return this.$store.state.roles[this.$store.state.currentRole].title;
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/global.scss";
nav.navbar {
  background-color: #fff;
  padding: 0 1rem;
  border-bottom: 2px solid $background;
  .navbar-brand {
    justify-content: center;
  }
}

.navbar-item:focus-visible {
  outline: $primary auto 1px;
}

.navbar-item img {
  max-height: 1.3rem;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.navlinks {
  margin-bottom: 24px;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50vh);
  opacity: 0;
}
#menu-toggle {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  color: #000;
  cursor: pointer;
}
@media screen and (min-width: $mobileMenuBreakpoint) {
  #menu-toggle {
    display: none;
  }
  .navbar-brand {
    justify-content: flex-start;
  }
}
</style>
